const AccountCircleMenu = () => {
  return (
    <svg width='88' height='88' viewBox='0 0 88 88' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M44 88C68.3005 88 88 68.3005 88 44C88 19.6995 68.3005 0 44 0C19.6995 0 0 19.6995 0 44C0 68.3005 19.6995 88 44 88Z'
        fill='#402080'
      />
      <path
        d='M44.0011 79.7724C61.1139 79.7724 74.9866 71.7644 74.9866 61.8862C74.9866 52.0079 61.1139 44 44.0011 44C26.8883 44 13.0156 52.0079 13.0156 61.8862C13.0156 71.7644 26.8883 79.7724 44.0011 79.7724Z'
        fill='#EDEFF1'
      />
      <path
        d='M43.9956 43.9989C53.8738 43.9989 61.8817 35.991 61.8817 26.1127C61.8817 16.2345 53.8738 8.22656 43.9956 8.22656C34.1173 8.22656 26.1094 16.2345 26.1094 26.1127C26.1094 35.991 34.1173 43.9989 43.9956 43.9989Z'
        fill='#EDEFF1'
      />
    </svg>
  )
}

export default AccountCircleMenu
